/**
 *
 * View of Topics on Front Page
 *
 * @author Space-Time Inc.
 *
 */


(function () {
	const MAX_COUNT = 9;

	const btn_a = document.getElementsByClassName('flt-all')[0];
	const btn_n = document.getElementsByClassName('flt-news')[0];
	const btn_e = document.getElementsByClassName('flt-event')[0];
	const btn_r = document.getElementsByClassName('flt-research')[0];

	const arch_n = document.getElementsByClassName('arch-news')[0];
	const arch_e = document.getElementsByClassName('arch-event')[0];
	const arch_r = document.getElementsByClassName('arch-research')[0];

	const list  = document.querySelector('.list-item-topic:not(.sticky)');
	const items = document.querySelectorAll('.list-item-topic:not(.sticky) > li');

	const on_click_a = () => {
		set_filter_type('a');
		set_item_visible('a', MAX_COUNT);
	};
	const on_click_n = () => {
		set_filter_type('n');
		set_item_visible('n', MAX_COUNT);
	};
	const on_click_e = () => {
		set_filter_type('e');
		set_item_visible('e', MAX_COUNT);
	};
	const on_click_r = () => {
		set_filter_type('r');
		set_item_visible('r', MAX_COUNT);
	};

	btn_a.addEventListener('click', on_click_a);
	btn_n.addEventListener('click', on_click_n);
	btn_e.addEventListener('click', on_click_e);
	btn_r.addEventListener('click', on_click_r);

	function set_filter_type(f) {
		arch_n.style.display = ('a' === f || 'n' === f) ? '' : 'none';
		arch_e.style.display = ('a' === f || 'e' === f) ? '' : 'none';
		arch_r.style.display = ('a' === f || 'r' === f) ? '' : 'none';

		if ('a' === f) list.dataset.filter = 'all';
		if ('n' === f) list.dataset.filter = 'news';
		if ('e' === f) list.dataset.filter = 'event';
		if ('r' === f) list.dataset.filter = 'research';

		btn_a.classList['a' === f ? 'add' : 'remove']('current');
		btn_n.classList['n' === f ? 'add' : 'remove']('current');
		btn_e.classList['e' === f ? 'add' : 'remove']('current');
		btn_r.classList['r' === f ? 'add' : 'remove']('current');
	}

	function set_item_visible(f, count) {
		let i = 0;
		for (; i < items.length; i += 1) {
			const it = items[i];

			const v = ('a' === f) ||
				('n' === f && 'news'     === it.dataset.type) ||
				('e' === f && 'event'    === it.dataset.type) ||
				('r' === f && 'research' === it.dataset.type);

			if (v) {
				it.style.display = '';
				count -= 1;
			}
			if (count === 0) break;
		}
		i += 1;
		for (; i < items.length; i += 1) {
			items[i].style.display = 'none';
		}
	}

	btn_a.click();
	list.classList.remove('first-view');
})();
